import { buildUploadsParams } from './lib';

// Multipart upload. Returns JSON (always HTTP 200; branch on payload.status).
export const uploadClaimsAction = ({ accountUuid, file, validateOnly }) => {
  const formData = new FormData();
  formData.append('file', file, file.name);
  const query = validateOnly ? '?validate-only' : '';
  return {
    method: 'POST',
    endpoint: `/accounts/${accountUuid}/claims-upload${query}`,
    body: formData,
  };
};

// Paginated history. Query params via buildUploadsParams.
export const getClaimUploadsAction = ({ accountUuid, pageSize, offset, fromDate, toDate, userUUID }) => {
  const params = buildUploadsParams({ pageSize, offset, fromDate, toDate, userUUID });
  const qs = Object.entries(params)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return {
    method: 'GET',
    endpoint: `/accounts/${accountUuid}/claims/uploads?${qs}`,
  };
};

// Account users for the "uploaded by" filter.
export const getAccountUsersAction = ({ accountUuid }) => ({
  method: 'GET',
  endpoint: `/accounts/${accountUuid}/users/search`,
});
